/**
 * Form validation utilities for the contact form.
 */

export interface FormErrors {
  name?: string;
  email?: string;
  phone?: string;
  company?: string;
  message?: string;
}

export interface FormData {
  name: string;
  email: string;
  phone: string;
  company: string;
  stage: string;
  message: string;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[\d\s\-+()]{7,20}$/;

export function validateForm(data: FormData): FormErrors {
  const errors: FormErrors = {};

  // Name validation
  if (!data.name.trim()) {
    errors.name = 'El nombre es obligatorio';
  } else if (data.name.trim().length < 2) {
    errors.name = 'El nombre debe tener al menos 2 caracteres';
  }

  // Email validation
  if (!data.email.trim()) {
    errors.email = 'El email es obligatorio';
  } else if (!EMAIL_REGEX.test(data.email)) {
    errors.email = 'Introduce un email válido';
  }

  // Phone validation (optional but must be valid if provided)
  if (data.phone && !PHONE_REGEX.test(data.phone)) {
    errors.phone = 'Introduce un teléfono válido (7-20 dígitos)';
  }

  // Message validation
  if (!data.message.trim()) {
    errors.message = 'El mensaje es obligatorio';
  } else if (data.message.trim().length < 10) {
    errors.message = 'El mensaje debe tener al menos 10 caracteres';
  }

  return errors;
}

export function isFormValid(errors: FormErrors): boolean {
  return Object.keys(errors).length === 0;
}
